<script>
  const serverPath="/";
  export default{
      serverPath,
  }
</script>



// WEBPACK FOOTER //
// src/components/Consts.vue